import { Skeleton, Stack } from '@ltvco/refresh-lib/theme';

interface INotificationsLoadingProps {
  count?: number;
}

const NotificationsLoading = ({ count = 8 }: INotificationsLoadingProps) => (
  <Stack width="100%" direction="column" mt={2}>
    {Array(count)
      .fill(0)
      .map((_, index) => (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={90}
          sx={{ mb: 1.5, borderRadius: 2 }}
          key={index}
        />
      ))}
  </Stack>
);

export default NotificationsLoading;
